import React, { useCallback } from 'react'
import { useTranslation, constants } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AciHighwayCargoKeys from '../../../constants/locale/key/AciHighwayCargo'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

const ACIHighwayCargoTranslationText = () => {
    const { translate } = useTranslation([
        Namespace.ACI_HIGHWAY_CARGO,
    ])

    let submitButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SUBMIT_BUTTON)
    let submitSuccessMsg = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SUBMIT_SUCCESS_MSG)
    let saveButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SAVE_BUTTON)
    let discardButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DISCARD_BUTTON)
    let discardContentMsg = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DISCARD_CONTENT_MSG)
    let discardOkMsg = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DISCARD_OK_MSG)
    let discardCancelMsg = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DISCARD_CANCEL_MSG)
    let updateButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.UPDATE_BUTTON)
    let noRecordsToDisplay =translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.NO_RECORD_TO_DISPLAY)
    let addCommodityButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ADD_COMMODITY_BUTTON)
    let actionButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ACTION_BUTTON)
    let editCargo = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.EDIT_CARGO)
    let cargoResponse  = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.RESPONSE_TITLE)
    let accountName  = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ACCOUNT_NAME)
    let portMismatch = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.PORT_MISMATCH)

    let draftStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DRAFT_STATUS)
    let acceptedStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ACCEPTED_STATUS)
    let sentStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SENT_STATUS)
    let rejectedStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.REJECTED_STATUS)
    let statusNotificationStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.STATUS_NOTIFICATION_STATUS)
    let cancellationAcceptedStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CANCELLATION_ACCEPTED_STATUS)
    let cancellationRejectedStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CANCELLATION_REJECTED_STATUS)
    let modificationRejectedStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.MODIFICATION_REJECTED_STATUS)
    let truckArrivedStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.TRUCK_ARRIVED_STATUS)
    let goodsReleasedStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.GOODS_RELEASED_STATUS)
    let pendingReview = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.PENDING_REVIEW)
    let reviewInProgress = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.REVIEW_IN_PROGRESS)
	  let reviewed = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.REVIEWED)
    let pendingEntryNumberStatus=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.PENDING_ENTRY_NUMBER)
	  let templateStatus=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.TEMPLATE)
    let reviewStatus=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.REVIEW_STATUS)
    let regularShipment=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.REGULAR_SHIPMENT)
    let inbondShipment=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.INBOND_SHIPMENT)
    let csaShipment=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CSA_SHIPMENT)
    let otherSystemCargo=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.OTHER_SYSTEM_CARGO_SHIPMENT)
    let cargoDeleteInProgressMsg=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_DELETE_IN_PROGRESS)
    let cargoMassDeleteSucceeded=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_MASS_DELETE_SUCCEEDED)
    let cargoMassDeleteError=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_MASS_DELETE_ERROR)
    let cargoDeleteSucceeded=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_DELETE_SUCCEEDED)
    let createCargoButton=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CREATE_CARGO_BUTTON)
    let cargoTemplateButton=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_TEMPLATE_BUTTON)

    let editButton=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.EDIT_BUTTON)
    let editSentRecords=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.EDIT_SENT_RECORDS)
    let cloneButton=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CLONE_BUTTON)
    let deleteButton=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DELETE_BUTTON)
    let deleteMultipleRecords=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DELETE_MULTIPLE_RECORDS)
    let addButton=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ADD_BUTTON)

    let exportCargoButton=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.EXPORT_CARGO_BUTTON)
    let maxRecordExportMsg=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.MAX_EXPORT_RECORD_MSG)
    let exportCargoBackgroundMsg=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.EXPORT_RECORD_BACKGROUND_MSG)

    let massDeleteButton=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.MASS_DELETE_BUTTON)
    let deleteContentMsg=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DELETE_CONTENT_MSG)
    let deleteConfirmMsg=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DELETE_CONFIRM_MSG)
    let deleteCancelMsg=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DELETE_CANCEL_MSG)

    let responseLogTab=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.RESPONSE_LOG_TAB)
    let viewCargo=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.VIEW_CARGO)
    let shipperConsOtherParty=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SH_CON_OTHER_PARTY)
    let templateAppliedSuccessMsg=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.TEMPLATE_APPLIED_SUCCESS_MSG)
    let historyTitle=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.HISTORY_TITLE)
    let shipmentInfoUpdate=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SHIPMENT_INFO_UPDATE)
    let docRefNo=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DOC_REF_NO)

    let csvTypeError=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SELECT_CSV_TYPE_ERROR)
    let fileSizeExceeded=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.FILE_SIZE_EXCEED)
    let invalidFile=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.INVALID_FILE)
    let csvUploadSuccess=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.UPLOAD_SUCCESS)
    let csvValidationError=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.VALIDATION_ERRORS)
    let csvuploadError=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ERROR_WHILE_UPLOADING)
    let cargoCsvUpload=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.UPLOAD_CARGO_FILE)
    let erroneousFileMsg=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ERRONEOUS_FILE)
    let uploadButtion=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.UPLOAD_BUTTON)
    let mandatoryFields=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.MANDATORY_FIELDS)
    let searchEntries=translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SEARCH_ENTRIES)
    return {
        submitButton,
        submitSuccessMsg,
        saveButton,
        discardButton,
        discardContentMsg,
        discardOkMsg,
        discardCancelMsg,
        updateButton,
        noRecordsToDisplay,
        addCommodityButton,
        actionButton,
        editCargo,
        cargoResponse,
        accountName,
        portMismatch,
        draftStatus,
        acceptedStatus,
        sentStatus,
        rejectedStatus,        
        statusNotificationStatus,
        cancellationAcceptedStatus,
        cancellationRejectedStatus,
        modificationRejectedStatus,
        truckArrivedStatus,
        goodsReleasedStatus,    
        pendingReview,
        reviewInProgress,
        reviewed,
        pendingEntryNumberStatus,
        templateStatus,
        reviewStatus,
        regularShipment,
        inbondShipment,
        csaShipment,
        otherSystemCargo,
        cargoDeleteInProgressMsg,
        cargoMassDeleteSucceeded,
        cargoMassDeleteError,
        cargoDeleteSucceeded,
        createCargoButton,
        cargoTemplateButton,
        editButton,
        editSentRecords,
        cloneButton,
        deleteButton,
        deleteMultipleRecords,
        exportCargoButton,
        maxRecordExportMsg,
        exportCargoBackgroundMsg,
        massDeleteButton,
        deleteContentMsg,
        deleteConfirmMsg,
        deleteCancelMsg,
        responseLogTab,
        viewCargo,
        addButton,
        shipperConsOtherParty,
        templateAppliedSuccessMsg,
        historyTitle,
        shipmentInfoUpdate,
        docRefNo,
        csvTypeError,
        fileSizeExceeded,
        invalidFile,
        csvUploadSuccess,
        csvValidationError,
        csvuploadError,
        cargoCsvUpload,
        erroneousFileMsg,
        uploadButtion,
        mandatoryFields,
        searchEntries
    }
}

export default ACIHighwayCargoTranslationText